var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7714 0.43881L3.8474 0.0948098C4.8564 -0.22719 5.9344 0.29381 6.3664 1.31181L7.2264 3.33981C7.6004 4.22281 7.3924 5.26181 6.7124 5.90781L4.8174 7.70581C4.9344 8.78181 5.2964 9.84081 5.9024 10.8828C6.47787 11.8909 7.24977 12.7734 8.1724 13.4778L10.4484 12.7178C11.3104 12.4308 12.2504 12.7618 12.7784 13.5388L14.0114 15.3488C14.6264 16.2528 14.5154 17.4988 13.7524 18.2648L12.9354 19.0858C12.1214 19.9028 10.9584 20.1998 9.8834 19.8638C7.3434 19.0718 5.0104 16.7208 2.8804 12.8108C0.747399 8.89481 -0.00560123 5.57081 0.622399 2.84281C0.886399 1.69481 1.7034 0.77981 2.7714 0.43881Z",
    fill: "#603DB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.92bea970485e5cbdfc87b8f26f74a6ad.svg";
export { ForwardRef as ReactComponent };